<template>
  <section class="content">
    <div class="box">
      <div class="box-header">
        <h3 class="box-title"><b>Organization Details</b></h3>
        <hr>
      </div>
      <div class="box-body" style="min-height: 800px;height: auto;">
        <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
          <div class="row">
            <div class="col-sm-12">
              <div class="box-header with-border" style="padding: 11px;padding-right: 0px; text-align:right">
                <div class="searchinput">
                  <input v-model="postsearch" type="text" class="search-text" placeholder="Search.." />
                  <span v-if="postsearch != ''" @click="postsearch=''; getalldata()">
                    <i class="fa fa-times"></i>
                  </span>
                  <button @click="getalldata()">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                <img src="../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
              </div>
              <div class="table-responsive text-nowrap" v-if="userslistlength > 0">
                <table id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size:12px">
                  <thead>
                    <tr role="row">
                      <th colspan="1"></th>
                      <th colspan="1">Organization Name</th>
                      <th colspan="1">Email</th>
                      <th colspan="1">Actual Cost</th>
                      <th colspan="1">Display Cost</th>
                      <th colspan="1">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd" v-for="(x) in orglist" :key="x.id">
                      <td>
                        <div class="Orgimage1">
                          <img v-if="x.profile_pic ==null || x.profile_pic ==''" class="round" src="../assets/img/default.png">
                          <img class="round" v-if="x.profile_pic !=null && x.profile_pic !=''" :src="`${x.profile_pic}`">
                        </div>
                      </td>
                      <td>{{ x.org_name }}</td>
                      <td>{{ x.email }}</td>
                      <td><i class="uil uil-rupee-sign"></i>{{ x.paid }}</td>
                      <td><i class="uil uil-rupee-sign"></i>{{ x.shown }}</td>
                      <td>
                        <a @click="updateCost(x)">Update Cost</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-if="userslistlength > 9">
            <div>
              <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
            </div>
            <div class="col-sm-12 tc">
              <jw-pagination :items="exampleItems" @changePage="onChangePage"></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal overlay fade in" id="modal-default" style="display: block;" v-show="showCostModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content AvailabilityPopup">
          <div class="modal-header">
            <h3 class="modal-title">
              <span>Update Cost</span>
              <button
                type="button"
                class="close"
                @click="onClose()"
              >
                <span aria-hidden="true" class="modalClose">&times;</span>
              </button>
            </h3>
          </div>
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12">
                  <div class="col-sm-12">
                    <div class="col-sm-12">
                      <span class="col-sm-3">
                        <label>Actual Cost</label>
                      </span>
                      <span class="col-sm-6">
                        <input
                          type="text"
                          class="form-control"
                          v-model="actualCost"
                          autofocus
                        />
                      </span>
                    </div>
                    <div class="col-sm-12 mt-2">
                      <span class="col-sm-3">
                        <label>Display Cost</label>
                      </span>
                      <span class="col-sm-6">
                        <input
                          type="text"
                          class="form-control"
                          v-model="displayCost"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: right;">
            <button class="btn btn-default" @click="onClose()">Close</button>
            <button class="btn btn-success" @click="submitCost()">Update</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import JwPagination from 'jw-vue-pagination'
import Vue from 'vue'
Vue.component('jw-pagination', JwPagination)

export default {
  name: 'Org-Details',
  data () {
    return {
      orglist: [],
      skip: 1,
      updateData: null,
      showCostModal: false,
      displayCost: '',
      actualCost: '',
      postsearch: '',
      userslistlength: 0
    }
  },
  created () {
    this.getalldata()
  },
  methods: {
    getalldata () {
      const data = {
        page: 1,
        search: this.postsearch
      }
      const mainurl = '/org/list_org'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.orglist = response.data.org
          this.userslistlength = response.data.total
          this.exampleItems = [...Array(response.data.total).keys()].map(i => (i))
        }
      }).catch(e => {
        console.log(e)
      })
    },
    onChangePage (pageOfItems) {
      let mainurl = ''
      if (pageOfItems.length > 0) {
        if (pageOfItems[0] === 0) {
          this.skip = 1
        } else {
          this.skip = (pageOfItems[0] / 10) + 1
        }
      }
      const data = {
        page: this.skip,
        search: this.postsearch
      }
      mainurl = '/org/list_org'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.orglist = response.data.org
        }
      }).catch(e => {
        console.log(e)
      })
    },
    updateCost (x) {
      this.updateData = x
      this.actualCost = x.paid
      this.displayCost = x.shown
      this.showCostModal = true
    },
    onClose () {
      this.showCostModal = false
    },
    submitCost () {
      const data = {
        paid: this.actualCost,
        shown: this.displayCost
      }
      const mainurl = '/org/' + this.updateData.id + '/update_org'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.showCostModal = false
          this.$awn.success('Organization cost updated successfully')
          this.getalldata()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.tc {
  text-align: center;
}
.table>thead>tr>th {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.Orgimage1 {
  border-radius: 50%;
}
.round {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  padding: 7px;
}
.searchArea {
  background-color: white;
}
.headposition {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.searchbar {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 5px;
  padding-right: 15px;
  background-color: white;
}
div.searchinput input[type="text"] {
  padding: 10px;
  font-size: 14px;
  border-right: none;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  float: left;
  width: 300px;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid grey;
  border-left: none;
  cursor: pointer;
}
div.searchinput span {
  float: left;
  width: 30px;
  padding: 10px;
  color: rgb(123, 117, 117);
  font-size: 14px;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
  border-left: none;
  border-right: none;
  cursor: pointer;
}

div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}
</style>
